class UndoRedoManager {
  constructor() {
    this.enabled = true;
    this.stores = {};
    this.undoStack = [];
    this.redoStack = [];
  }

  /**
   * Sets the manager's enabled state
   * @param {boolean} state 
   */
  setEnabled(state) {
    this.enabled = state;
  }

  addStore(name, store) {
    this.stores[name] = store;
  }

  removeStore(name) {
    delete this.stores[name];
  }

  canUndo() {
    return this.enabled && this.undoStack.length > 0;
  }

  canRedo() {
    return this.enabled && this.redoStack.length > 0;
  }

  save() {
    if (!this.enabled) return;
    
    this.redoStack = [];

    this.undoStack.push(this.getCurrent());
  }

  undo() {
    if (!this.enabled) return;

    var states = this.undoStack.pop();

    this.redoStack.push(this.getCurrent());

    this.setStates(states);
  }

  redo() {
    if (!this.enabled) return;

    var states = this.redoStack.pop();

    this.undoStack.push(this.getCurrent());

    this.setStates(states);
  }

  reset() {
    this.undoStack = [];
    this.redoStack = [];
  }

  getCurrent() {
    var appState = {};

    for (var storeName in this.stores) {
      var store = this.stores[storeName];

      appState[storeName] = store.getCurrentState();
    }

    return appState;
  }

  setStates(states) {
    for (var storeName in states) {
      var store = this.stores[storeName];
      var storeState = states[storeName];

      store.applyState(storeState);
    }
  }
}

export default new UndoRedoManager();
